import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  Table as Tbl,
  Tabs,
  Form,
  Button,
  Heading,
  DateInput,
  Input,
  NumberInput,
  Text,
  Card,
  IconButton,
  Panel,
  SelectPicker,
  toaster,
  Message,
  DatePicker,
  Drawer,
  Carousel,
  List,
  Modal,
  Textarea,
  HStack,
} from "rsuite";
import axios from "../axiosIn";
import {
  FaBookMedical,
  FaFolder,
  FaSave,
  FaSearch,
  FaShare,
  FaUpload,
  FaUser,
} from "react-icons/fa";
import { useReactToPrint } from "react-to-print";
import { LucideZoomIn, PrinterIcon, SearchIcon } from "lucide-react";
import { LuCopy } from "react-icons/lu";
import { VscEdit, VscSave } from "react-icons/vsc";
import Table from "react-bootstrap/Table";
import { Image } from "react-bootstrap";
import { confApp } from "../CONF_APP";
import moment from "moment/moment";

const { Column, HeaderCell, Cell } = Tbl;

export const Pacientes = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedicoLab] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedicoLab,
  );
  const [esMedicoLab] = useState(
    JSON.parse(localStorage.getItem("auth")).esMedicoLab,
  );
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [appConfigParams] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp,
  );

  const componentRef = useRef();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idMedico = JSON.parse(localStorage.getItem("auth")).idMedico;
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [disabledAnteced] = useState(idMedico === 0 ? true : false);
  const [disabledExped] = useState(idMedico === 0 ? true : false);
  const [data, setData] = useState([]);
  const [dataExped, setDataExped] = useState([]);
  const [open, setOpen] = useState(false);
  const [tituloDrawer, setTituloDrawer] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [dataSignosEx, setdataSignosEx] = useState([]);
  const [tratamiento, setTratamiento] = useState("");
  const [indicaciones, setIndicaciones] = useState("");
  const [motivoEx, setMotivoEx] = useState("");
  const [cambioFecha, setCambioFecha] = useState(false);

  const [valueGpo1, setValueGpo1] = useState("");
  const [valueGpo2, setValueGpo2] = useState("");
  const [valueGpo3, setValueGpo3] = useState("");
  const [valueGpo4, setValueGpo4] = useState("");

  const [dataAnteced, setDataAnteced] = useState([]);
  const [antecedente, setAntecedente] = useState({ nombre: "", detalles: [] });
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();

  const [sortColumnExped, setSortColumnExped] = useState();
  const [sortTypeExped, setSortTypeExped] = useState();

  const [loading, setLoading] = useState(false);
  const [loadingExped, setLoadingExped] = useState(false);

  const [filtro, setFiltro] = useState("NULL");
  const [expediente, setExpediente] = useState(false);
  const [loaderDatos, setLoaderDatos] = useState(false);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], dataAnteced);
    nextData.find((item) => item.id === id)[key] = value;
    setDataAnteced(nextData);
  };

  const handleEdit = (id) => {
    const nextData = Object.assign([], dataAnteced);
    const activeItem = nextData.find((item) => item.id === id);
    activeItem.status = activeItem.status ? null : "EDIT";
    setDataAnteced(nextData);
  };

  const [message, setMessage] = useState("");

  // CONSTANTES DATOS DEL PACIENTE
  const [paciente, setPaciente] = useState("");
  const [idConsulta, setIdConsulta] = useState(0);
  const [observaCita, setObservaCita] = useState("");
  const [idPac, setIdPac] = useState(0);
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [colonia, setColonia] = useState("");
  const [fecNac, setFecNac] = useState("");
  const [estado, setEstado] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [file, setFile] = useState({});
  const [dataNivelEstud, setDataNivEstud] = useState(confApp.NIVEL_ESTUDIO);
  const [nivelEstud, setNivelEstud] = useState("");
  const [religion, setReligion] = useState("");
  const [edad, setEdad] = useState(0);
  const [medicosAsignados, setMedicosAsignados] = useState("");
  const [listaMedicosLab, setListaMedicosLab] = useState([]);
  const [medicoLabFiltro, setMedicoLabFiltro] = useState(0);

  const printerRef = React.useRef(null);

  const [listEdoCivil] = useState([
    { label: "", value: "" },
    { label: "Soltero(a)", value: "Soltero(a)" },
    { label: "Casado(a)", value: "Casado(a)" },
    { label: "Divorciado(a)", value: "Divorciado(a)" },
    { label: "Viudo(a)", value: "Viudo(a)" },
    { label: "Union Libre", value: "Union Libre" },
    { label: "Otro", value: "Otro" },
  ]);
  const [edoCivil, setEdoCivil] = useState("");
  const [listGeneros] = useState([
    { label: "", value: "" },
    { label: "Femenino", value: "Femenino" },
    { label: "Masculino", value: "Masculino" },
    { label: "Otro", value: "Otro" },
  ]);
  const [genero, setGenero] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);
  const [linkDoc, setLinkDoc] = useState("#");
  const [fileName, setFileName] = useState("");
  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);
  const [link] = useState(confApp.LINK_DOC);
  const [modalReceta, setModalReceta] = useState(false);

  // ------------------------------------------------------------ HISTORICOS DE EXPLORACION ------------------------------
  const [frecCardiacaEx, setFrecCardiacaEx] = useState("");
  const [frecRespEx, setFrecRespEx] = useState("");
  const [tempEx, setTempEx] = useState("");
  const [presionArtEx, setPresioArtEx] = useState("");
  const [pesoEx, setPesoEx] = useState("");
  const [tallaEx, setTallaEx] = useState("");
  const [imcEx, setImcEx] = useState("");
  const [saturaOxEx, setSaturaOxEx] = useState("");
  const [glicemiaCapEx, setGlicemiaCapEx] = useState("");
  const [otrosDatosExploraEx, setOtrosDatosExploraEx] = useState("");
  const [labsEstudiosEx, setLabsEstudiosEx] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DE VARIABLES DE EXPLORACION FISICA

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const handleSortColumnExped = (sortColumn, sortType) => {
    setLoadingExped(true);
    setTimeout(() => {
      setLoadingExped(false);
      setSortColumnExped(sortColumn);
      setSortTypeExped(sortType);
    }, 500);
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "55mm";
  const marginRight = "25mm";
  const marginBottom = "25mm";
  const marginLeft = "25mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Receta",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const getPacientes = async () => {
    const abortController = new AbortController();
    if (!filtro) {
      await setFiltro("NULL");
    }

    var url = `Pacientes/getPacientes/${idNegocio}/${filtro}/${idMedicoLab}/${medicoLabFiltro}`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      setData(response.data);
      loadMedicosLab();
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

  const handleChangeMedicoFiltro = (e) => {
    if (e === null) {
      setMedicoLabFiltro(0);
    } else {
      setMedicoLabFiltro(e);
    }
  };

  const handleClose = () => {
    setModalReceta(false);
  };

  const getDatosCita = async (idCons) => {
    var url = `Consultas/getDatosCitaPorIdConsulta/${idNegocio}/${idCons}`;

    await axios
      .get(url)
      .then((response) => {
        console.log(response.data.dataSignos);
        // DATOS DE EXPLORACION FISICA
        setFrecCardiacaEx(response.data.dataSignos.frecCardiaca);
        setFrecRespEx(response.data.dataSignos.frecResp);
        setTempEx(response.data.dataSignos.temp);
        setPresioArtEx(response.data.dataSignos.presionArt);
        setPesoEx(response.data.dataSignos.peso);
        setTallaEx(response.data.dataSignos.talla);
        setImcEx(response.data.dataSignos.imc);
        setSaturaOxEx(response.data.dataSignos.saturaOx);
        setGlicemiaCapEx(response.data.dataSignos.glicemiaCap);
        setOtrosDatosExploraEx(response.data.dataSignos.otrosDatosExp);
        setLabsEstudiosEx(response.data.dataSignos.labsEstudios);
        setdataSignosEx(response.data.dataExplora);
        setMotivoEx(response.data.motivo);
        getDocsCita(response.data.idConsulta);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPaciente = async (_idPac) => {
    const abortController = new AbortController();
    var url = `Pacientes/getDatosPaciente/${idNegocio}/${_idPac}`;

    try {
      await axios
        .get(url)
        .then((response) => {
          setIdPac(_idPac);
          setExpediente(true);
          setPaciente(response.data.paciente);
          let _fecha = response.data.fechaNac;
          if (_fecha !== null) {
            var _fecNac = new Date(response.data.fechaNac);
            _fecNac.setDate(_fecNac.getDate() + 1);
            calculaEdad(_fecNac);
            setFecNac(_fecNac);
          } else {
            setEdad(0);
            setFecNac(null);
          }
          setDomicilio(response.data.calleNum);
          setColonia(response.data.colonia);
          setEstado(response.data.estado);
          setMunicipio(response.data.municipio);
          setTelefono(response.data.telefono);
          setCorreo(response.data.correo);
          setEdoCivil(response.data.edoCivil);
          setNivelEstud(response.data.nivelEstud);
          setReligion(response.data.religion);
          setMedicosAsignados(response.data.medicos);

          if (response.data.linkDoc !== null) {
            setLinkDoc(
              `${link}/${idNegocio}/${_idPac}/${response.data.linkDoc}`,
            );
            setMessage(
              `Buen día le escribimos de ${negocio.NomConsultorio}, para hacerle llegar su link: \n${link}/${idNegocio}/${_idPac}/${response.data.linkDoc} `,
            );
          } else {
            setLinkDoc(``);
            setMessage(
              `Buen día le escribimos de ${negocio.NomConsultorio}, para hacerle llegar su link: `,
            );
          }

          if (response.data.genero === null) {
            setGenero("");
          } else {
            setGenero(response.data.genero);
          }
          setOcupacion(response.data.ocupacion);
          getAntecedentes(_idPac);
        })
        .then((next) => {
          getExpedientePaciente(_idPac);
        });
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

  const loadMedicosLab = async () => {
    var url = `Consultas/getMedicosLab/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListaMedicosLab(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveDatos = async () => {
    var url = `Pacientes/saveDatos`;

    const data = {
      id: idNegocio,
      idPaciente: idPac,
      paciente: paciente,
      fechaNac: fecNac,
      calleNum: domicilio,
      colonia: colonia,
      telefono: telefono,
      correo: correo,
      ocupacion: ocupacion,
      genero: genero,
      edoCivil: edoCivil,
      estado: estado,
      municipio: municipio,
      nivelEstudio: nivelEstud,
      religion: religion,
    };

    setLoaderDatos(true);

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data === 1) {
          getPacientes();
          toast("Los datos se han actualizado de forma correcta.", "success");
          setLoaderDatos(false);
        }
      })
      .catch((error) => {
        setLoaderDatos(false);
        toast("Error al enviar los datos.", "warning");
        console.log(error);
      });
  };

  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const getDataExped = () => {
    if (sortColumn && sortType) {
      return dataExped.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return dataExped;
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleChangeValueExplora = (e, idGpo) => {
    if (idGpo === 1) {
      setValueGpo1(e);
    }
    if (idGpo === 2) {
      setValueGpo2(e);
    }
    if (idGpo === 3) {
      setValueGpo3(e);
    }
    if (idGpo === 4) {
      setValueGpo4(e);
    }
  };

  const handleFechaNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);

      const hoy = new Date(); // Fecha actual
      const fechaNac = new Date(e); // Fecha de nacimiento del input

      let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

      const mesActual = hoy.getMonth();
      const mesNac = fechaNac.getMonth();
      setCambioFecha(true);
      // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
      if (mesActual < mesNac) {
        edad--;
      } else if (mesActual === mesNac) {
        // Si los meses son iguales, revisamos el día
        const diaActual = hoy.getDate();
        const diaNac = fechaNac.getDate();
        if (diaActual < diaNac) {
          edad--; // No ha cumplido años aún en el mes actual
        }
      }

      // Para obtener meses y días exactos (más complejo, pero posible)
      // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
      // El método anterior solo da los años cumplidos.
      setEdad(edad);
    }
  };

  const getExpediente = async (props) => {
    const dataPaciente = {
      idPaciente: props.idPac,
    };
    localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
    getPaciente(props.idPac);
  };

  const getAntecedentes = async (ID) => {
    var url = `Consultas/getAntecedentes/${idNegocio}/${ID}`;

    await axios
      .get(url)
      .then(async (response) => {
        setListaAnteced(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCellChange = async (props) => {
    var url = "Consultas/saveItem";
    const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

    const data = {
      opc: props.opc,
      id: idNegocio,
      idPaciente: idPac,
      idAnteced: props.idAnteced,
      noItem: props.id,
      valorado: props.opc === "resp" ? props.valor : "",
      obs: props.opc === "resp" ? "" : props.texto,
    };

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        toast("Se ha registrado la información.", "success");
      })
      .catch((error) => {
        toast("Ocurrio un error al guardar.", "error");
      });
  };

  const getExpedientePaciente = async (ID) => {
    var url = `Pacientes/getExpediente/${idNegocio}/${ID}`;

    await axios
      .get(url)
      .then((response) => {
        setDataExped(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDocsCita = async (idConsulta) => {
    var url = `Consultas/getDocsCita/${idNegocio}/${idConsulta}`;
    setIdConsulta(idConsulta);
    await axios
      .get(url)
      .then((response) => {
        let doc = [];

        response.data.forEach((element) => {
          doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
        });
        setImageList(doc);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const copiarEnlace = async (value) => {
    await navigator.clipboard.writeText(value);
    toast("Enlace copiado", "success");
  };

  const handleFile = (e) => {
    setFile(e.target.files);
  };

  const saveDocument = async () => {
    var url = "saveDoc";
    const formData = new FormData();
    formData.append("id", idNegocio);
    formData.append("idPaciente", idPac);
    formData.append("file", file[0]);
    formData.append("idUser", idUser);
    formData.append("expedAnt", 0);

    await axios
      .post("Consultas/saveDoc", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data !== "") {
          toast("El documento se ha cargado de forma correcta", "success");
          setLinkDoc(`${link}/${idNegocio}/${idPac}/${res.data}`);
          setMessage(
            `Buen día le escribimos de ${negocio.NomConsultorio}, para hacerle llegar su link: \n${link}/${idNegocio}/${idPac}/${res.data}`,
          );
          setFileName(res.data);
        } else {
          toast("Ocurrio un error al subir el documento", "error");
          setLinkDoc("#");
        }
      })
      .catch((error) => {
        toast(
          "Ocurrio un error inesperado, valide su conexión a internet",
          "error",
        );
        console.log(error);
      });
  };

  const getFinalText = (text) => {
    const lines = text.split("\n");
    return (
      <div>
        {lines.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const addMedico = async (e) => {
    if (e === null) {
      return;
    }

    var url = "Pacientes/addMedico";

    const data = {
      id: idNegocio,
      idConsulta: idConsulta,
      idMedico: e,
    };

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data > 0) {
          toast("Se asigno el expediente al médico.", "success");
          getPaciente(idPac);
        } else {
          toast("La asignación ya existe...", "error");
        }
      })
      .catch((error) => {
        toast("Ocurrio un error al guardar.", "error");
      });
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${message}`;
    anchor.target = "_blank";
    anchor.click();
  };

  const getDetalles = async (props) => {
    getDatosCita(props.idC);
    setTituloDrawer(props.titulo);
    setDiagnostico(props.diagnostico);
    setTratamiento(props.tratamiento);
    setIndicaciones(props.indicaciones);
    setObservaCita(props.observa);
    setOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    getPacientes();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [imageList]);

  return (
    <>
      <div
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "15px",
        }}
      >
        <Form layout="inline">
          <Form.Group controlId="filtro">
            <Form.Label>Buscar por...</Form.Label>
            <HStack>
              <Form.Control
                name="filtro"
                onChange={(e) => setFiltro(e)}
                autoFocus
                placeholder="Nombre, apellidos o teléfono..."
              />
            </HStack>
          </Form.Group>
          {appConfigParams.esLaboratorio === 1 ? (
            idMedicoLab > 0 ? (
              ""
            ) : (
              <Form.Group controlId="medicos">
                <Form.Label>Mostrar por médico</Form.Label>
                <SelectPicker
                  data={listaMedicosLab}
                  placeholder="-- TODOS --"
                  width={450}
                  onChange={(e) => handleChangeMedicoFiltro(e)}
                />
              </Form.Group>
            )
          ) : (
            ""
          )}

          <Button appearance="primary" onClick={getPacientes}>
            Buscar &nbsp; <FaSearch></FaSearch>
          </Button>
        </Form>
        <br></br>
        <Tbl
          height={300}
          hover={true}
          showHeader={true}
          data={getData}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          loading={loading}
          bordered={true}
          cellBordered={true}
          headerHeight={30}
          rowHeight={40}
          key={`id-tbl-1`}
          id="tbl-1"
        >
          <Column width={350} resizable sortable>
            <HeaderCell>Paciente</HeaderCell>
            <Cell dataKey="paciente" />
          </Column>

          <Column width={50} fixed sortable>
            <HeaderCell></HeaderCell>
            <Cell style={{ padding: "6px" }} align="center">
              {(rowData) => (
                <Button
                  appearance="subtle"
                  size="sm"
                  title="Click para mostrar datos"
                  onClick={() =>
                    getExpediente({
                      idPac: rowData.idPaciente,
                      paciente: rowData.paciente,
                    })
                  }
                >
                  <LucideZoomIn />
                </Button>
              )}
            </Cell>
          </Column>

          <Column width={120} fixed sortable>
            <HeaderCell>Genero</HeaderCell>
            <Cell dataKey="genero" />
          </Column>

          <Column flexGrow={1} width={120} fixed sortable>
            <HeaderCell align="center">Teléfono</HeaderCell>
            <Cell dataKey="telefono" align="center" />
          </Column>

          <Column width={50} fixed sortable>
            <HeaderCell align="center">Citas</HeaderCell>
            <Cell dataKey="citas" align="center" />
          </Column>

          <Column width={80} fixed sortable>
            <HeaderCell align="center">Consultas</HeaderCell>
            <Cell dataKey="consultas" align="center" />
          </Column>
        </Tbl>
        <hr />
        <br></br>
        {expediente ? (
          <>
            <Heading level={isMobile ? 9 : 5}>Paciente: {paciente}</Heading>
            <br></br>
            <Tabs
              defaultActiveKey="1"
              bordered
              appearance={isMobile ? "subtle" : "tabs"}
              style={{ fontSize: isMobile ? "12px" : "16px" }}
            >
              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB DATOS GENERALES */}
              <Tabs.Tab
                eventKey="1"
                title={isMobile ? <FaUser></FaUser> : "Datos Generales"}
              >
                <Card bordered style={{ height: "750px", padding: "20px" }}>
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Nombre completo</b>
                      <Input
                        value={paciente}
                        onChange={(e) => setPaciente(e)}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Fecha de nacimiento</b>
                      <DateInput
                        format="dd/MM/yyyy"
                        id="fecNac"
                        name="fecNac"
                        value={fecNac}
                        onChange={(e) => handleFechaNac(e)}
                      />
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1">
                      <b>Edad</b>
                      <Input
                        readOnly
                        value={edad}
                        style={{ textAlign: "center" }}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Teléfono</b>
                      <NumberInput
                        controls={false}
                        id="telefono"
                        maxLength={10}
                        min={0}
                        value={telefono}
                        onChange={(e) => setTelefono(e)}
                      />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <b>Correo</b>
                      <Input
                        value={correo}
                        name="correo"
                        onChange={(e) => setCorreo(e)}
                      />
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col">
                      <Panel bordered header="Domicilio">
                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <b>Calle y número</b>
                            <Input
                              value={domicilio}
                              onChange={(e) => setDomicilio(e)}
                            />
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <b>Colonia</b>
                            <Input
                              value={colonia}
                              onChange={(e) => setColonia(e)}
                            />
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <b>Estado</b>
                            <Input
                              value={estado}
                              onChange={(e) => setEstado(e)}
                            />
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <b>Municipio</b>
                            <Input
                              value={municipio}
                              onChange={(e) => setMunicipio(e)}
                            />
                          </div>
                        </div>
                      </Panel>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Estado Civil</b>
                      <SelectPicker
                        searchable={false}
                        data={listEdoCivil}
                        value={edoCivil}
                        placeholder="Selecciona"
                        onChange={(e) => setEdoCivil(e)}
                        style={{ width: "auto" }}
                        block
                      ></SelectPicker>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Genero</b>
                      <SelectPicker
                        block
                        searchable={false}
                        data={listGeneros}
                        value={genero}
                        placeholder="Selecciona"
                        onChange={(e) => setGenero(e)}
                      ></SelectPicker>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Ocupación</b>
                      <Input
                        value={ocupacion}
                        onChange={(e) => setOcupacion(e)}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Nivel Estudios</b>
                      <SelectPicker
                        searchable={false}
                        data={dataNivelEstud}
                        value={nivelEstud}
                        placeholder="Selecciona"
                        onChange={(e) => setNivelEstud(e)}
                        style={{ width: "auto" }}
                        block
                      ></SelectPicker>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <b>Religión</b>
                      <Input
                        value={religion}
                        onChange={(e) => setReligion(e)}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <br></br>
                      <Button
                        appearance="primary"
                        block
                        disabled={esMedicoLab === 1 ? true : false}
                        loading={loaderDatos}
                        onClick={saveDatos}
                      >
                        <FaSave></FaSave>&nbsp; Guardar
                      </Button>
                    </div>
                  </div>
                </Card>
              </Tabs.Tab>
              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB Antecedentes */}
              <Tabs.Tab
                eventKey="2"
                title={
                  isMobile ? (
                    <FaBookMedical></FaBookMedical>
                  ) : (
                    "Historia Clínica"
                  )
                }
                disabled={disabledAnteced}
              >
                {listaAnteced.length > 0
                  ? listaAnteced.map((itm, index) => {
                      return (
                        <div key={`div-${index}`}>
                          <Accordion.Panel
                            header={`${itm.nombre}`}
                            bordered
                            defaultExpanded={false}
                            key={`accord-${index}`}
                          >
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              key={`tbl-${index}`}
                              style={{
                                width: "100%",
                                cellPadding: "5",
                                cellSpacing: "10",
                                fontSize: isMobile ? "10px" : "16px",
                              }}
                              cellPadding={10}
                              cellSpacing={10}
                            >
                              <thead key={`headers-${index}`}>
                                <tr
                                  key={`fila-${index}`}
                                  style={{
                                    borderBottom: "solid 2px",
                                    paddingBottom: "15",
                                  }}
                                >
                                  {isMobile ? (
                                    ""
                                  ) : (
                                    <th
                                      key={`header0-${index}`}
                                      style={{
                                        textAlign: "center",
                                        width: "5%",
                                      }}
                                    >
                                      <b>#</b>
                                    </th>
                                  )}
                                  <th
                                    key={`header1-${index}`}
                                    style={{ width: "30%" }}
                                  >
                                    <b>Item</b>
                                  </th>
                                  <th
                                    key={`header2-${index}`}
                                    style={{
                                      width: "15%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <b>Respuesta</b>
                                  </th>
                                  <th
                                    key={`header3-${index}`}
                                    style={{ width: "50%" }}
                                  >
                                    <b>Observaciones</b>
                                  </th>
                                </tr>
                              </thead>
                              {itm.detalles.map((item, ix) => {
                                return (
                                  <tr key={`fila-${ix}`}>
                                    {isMobile ? (
                                      ""
                                    ) : (
                                      <td
                                        key={`celda1-${ix}`}
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.id}
                                      </td>
                                    )}
                                    <td key={`celda2${index}-${ix}`}>
                                      {item.Item}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <select
                                        key={`select-${ix}`}
                                        style={{ border: "none" }}
                                        disabled={true}
                                        onChange={(e) =>
                                          handleCellChange({
                                            opc: "resp",
                                            idAnteced: item.idAnteced,
                                            id: item.id,
                                            valor: e.target.value,
                                          })
                                        }
                                      >
                                        <option
                                          key={`opt-select-SinVal-${ix}-${index}`}
                                          value=""
                                          selected={
                                            item.valorado === "" ? true : false
                                          }
                                        ></option>
                                        <option
                                          key={`opt-select-SI-${ix}-${index}`}
                                          value="SI"
                                          selected={
                                            item.valorado === "SI"
                                              ? true
                                              : false
                                          }
                                        >
                                          SI
                                        </option>
                                        <option
                                          key={`opt-select-NO-${ix}-${index}`}
                                          value="NO"
                                          selected={
                                            item.valorado === "NO"
                                              ? true
                                              : false
                                          }
                                        >
                                          NO
                                        </option>
                                      </select>
                                    </td>
                                    <td key={`obs-${index}${ix}`}>
                                      <Input
                                        value={item.observacion}
                                        readOnly
                                        defaultValue={item.observacion}
                                        style={{
                                          fontSize: isMobile ? "10px" : "16px",
                                        }}
                                        onBlur={(e) =>
                                          handleCellChange({
                                            opc: "obs",
                                            idAnteced: item.idAnteced,
                                            id: item.id,
                                            texto: e.target.value,
                                          })
                                        }
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </Table>
                          </Accordion.Panel>
                        </div>
                      );
                    })
                  : ""}
              </Tabs.Tab>
              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB Expediente */}
              <Tabs.Tab
                eventKey="3"
                title={isMobile ? <FaFolder></FaFolder> : "Expediente"}
                disabled={disabledExped}
              >
                <Card bordered style={{ height: "370px", padding: "20px" }}>
                  <div className="row">
                    <div className="col">
                      <Tbl
                        height={300}
                        hover={true}
                        showHeader={true}
                        data={getDataExped}
                        sortColumn={sortColumnExped}
                        sortType={sortTypeExped}
                        onSortColumn={handleSortColumnExped}
                        loading={loadingExped}
                        bordered={true}
                        cellBordered={true}
                        headerHeight={30}
                        rowHeight={40}
                        key={`id-tbl-3`}
                        id="tbl-3"
                      >
                        <Column width={0} align="center">
                          <HeaderCell>Id</HeaderCell>
                          <Cell dataKey="idConsulta" />
                        </Column>

                        <Column width={0} align="center">
                          <HeaderCell>Id</HeaderCell>
                          <Cell dataKey="idExped" />
                        </Column>

                        <Column align="center" sortable width={340}>
                          <HeaderCell align="center">Fecha</HeaderCell>
                          <Cell dataKey="fecha" />
                        </Column>

                        <Column width={50} fixed>
                          <HeaderCell></HeaderCell>
                          <Cell style={{ padding: "6px" }} align="center">
                            {(rowData) => (
                              <Button
                                appearance="subtle"
                                size="sm"
                                onClick={() =>
                                  getDetalles({
                                    idC: rowData.idConsulta,
                                    idPac: idPac,
                                    titulo: `EXPED-${rowData.idExped}-${rowData.idConsulta} / Fecha: ${rowData.fecha}`,
                                    diagnostico: rowData.diagnostico,
                                    tratamiento: rowData.tratamiento,
                                    indicaciones: rowData.inidcaciones,
                                    observa: rowData.observa,
                                  })
                                }
                              >
                                <LucideZoomIn />
                              </Button>
                            )}
                          </Cell>
                        </Column>

                        <Column width={250} flexGrow={true}>
                          <HeaderCell>Motivo Consulta</HeaderCell>
                          <Cell dataKey="motivoConsulta" />
                        </Column>

                        <Column width={0} fixed resizable sortable>
                          <HeaderCell>Diagnostico</HeaderCell>
                          <Cell dataKey="diagnostico"></Cell>
                        </Column>

                        <Column
                          width={310}
                          fixed
                          flexGrow={true}
                          resizable
                          sortable
                        >
                          <HeaderCell>Tratamiento</HeaderCell>
                          <Cell dataKey="tratamiento" />
                        </Column>

                        <Column width={0} fixed resizable sortable>
                          <HeaderCell>Indicaciones</HeaderCell>
                          <Cell dataKey="inidcaciones" />
                        </Column>

                        <Column width={100} fixed resizable>
                          <HeaderCell align="center">Docs</HeaderCell>
                          <Cell dataKey="Docs" align="center" />
                        </Column>
                      </Tbl>
                    </div>
                  </div>
                </Card>
              </Tabs.Tab>

              {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB UPLOAD DOCUMENTO */}
              {appConfigParams.esLaboratorio === 1 ? (
                ""
              ) : (
                <Tabs.Tab
                  eventKey="4"
                  title={isMobile ? <FaShare></FaShare> : "Compartir documento"}
                >
                  <Panel bordered shaded>
                    <div className="row mb-3">
                      <b>Subir documento</b>
                      <div className="col-lg-10 col-md-10 cols-sm-10">
                        <input
                          type="file"
                          id="file"
                          onChange={(e) => handleFile(e)}
                        />
                      </div>
                      &nbsp;
                      <div className="text-end col-lg-1col-md-1 col-sm-1">
                        <Button
                          color="primary"
                          block
                          disabled={file.length > 0 ? false : true}
                          onClick={() => saveDocument()}
                        >
                          <FaUpload></FaUpload>&nbsp; Subir archivo...
                        </Button>
                      </div>
                    </div>
                    <div className="row">
                      <b>Link para el paciente</b>
                      <div className="col">
                        <a href={linkDoc} target="_blank" rel="noreferrer">
                          {linkDoc}
                        </a>
                      </div>
                    </div>
                    <br></br>
                    <div className="row">
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <b>Copiar enlace</b>
                        <br></br>
                        <Button
                          size="sm"
                          onClick={() => copiarEnlace(linkDoc)}
                          title="Copiar enlace"
                          appearance="subtle"
                        >
                          <LuCopy></LuCopy>
                        </Button>
                      </div>
                      <div className="col-lg-5 col-md-5 col-sm-5">
                        <b>Mensaje</b>
                        <Input
                          as="textarea"
                          rows={3}
                          value={message}
                          defaultValue={message}
                          onChange={(e) => setMessage(e)}
                        />
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <b>Envío a</b>
                        <Input
                          readOnly
                          value={`${paciente} - Teléfono: ${telefono}`}
                        />
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <br></br>
                        <Button
                          appearance="ghost"
                          onClick={() => sendMessage()}
                          size="sm"
                        >
                          <Image
                            src="/Images/whatsapp.png"
                            style={{ height: "30px" }}
                          ></Image>
                          &nbsp; Enviar mensaje
                        </Button>
                      </div>
                    </div>
                  </Panel>
                </Tabs.Tab>
              )}
            </Tabs>

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER EXPEDIENTE PACIENTE */}
            <Drawer size="full" open={open} onClose={() => setOpen(false)}>
              <Drawer.Header>
                <Drawer.Title>
                  {paciente} <br /> {tituloDrawer}
                </Drawer.Title>
              </Drawer.Header>
              <Drawer.Body>
                <Card>
                  <Card.Body>
                    <Text size={"md"} weight="bold">
                      Motivo de consulta
                    </Text>
                    {motivoEx}
                  </Card.Body>
                </Card>
                {appConfigParams.mostrarExplora === 1 ? (
                  <div className="row mb-1">
                    <div className="col">
                      <Panel
                        bordered
                        header="Exploración Física"
                        defaultExpanded
                        key="panelExploraFisExpedinete"
                      >
                        <div className="row">
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Peso</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={pesoEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Talla</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={tallaEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">IMC</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={imcEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Presión arterial">
                              TA
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={presionArtEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Frec. Cardiaca">
                              FC
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={frecCardiacaEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Frec. Respiratoria">
                              FR
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={frecRespEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Temperatura">
                              <b>T</b>emperatura
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={tempEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Saturación de O2">
                              Sp<b>O</b>2
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={saturaOxEx}
                              readOnly
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Glicemia capilar</Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={glicemiaCapEx}
                              readOnly
                            />
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Text size="sm">Otros datos</Text>
                            <Input
                              as="textarea"
                              placeholder="Generales de la exploración..."
                              rows={3}
                              value={otrosDatosExploraEx}
                              readOnly
                            />
                          </div>
                        </div>
                      </Panel>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {dataSignosEx.length > 0 ? (
                  <div className="row mb-2">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card1-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-1-Ex`}
                        >
                          <b>{dataSignosEx[0].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-1-Ex`}>
                          <Textarea
                            key={`gpo1-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[0].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[0].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card2-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-2-Ex`}
                        >
                          <b>{dataSignosEx[1].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-2-Ex`}>
                          <Textarea
                            key={`gpo2-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[1].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[1].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card-3-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-3-Ex`}
                        >
                          <b>{dataSignosEx[2].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-3-Ex`}>
                          <Textarea
                            key={`gpo3-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[2].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[2].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Card key={`card-4-Ex`}>
                        <Card.Header
                          style={{ fontSize: "12px" }}
                          key={`cardHeader-4-Ex`}
                        >
                          <b>{dataSignosEx[3].nombre}</b>
                        </Card.Header>
                        <Card.Body key={`cardBody-4-Ex`}>
                          <Textarea
                            key={`gpo4-Ex`}
                            rows={4}
                            readOnly
                            value={dataSignosEx[3].items[0]}
                            onChange={(e) =>
                              handleChangeValueExplora(e, dataSignosEx[3].idGpo)
                            }
                          />
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="row mb-2">
                  <div className="col">
                    <List style={{ flex: 1 }} bordered>
                      <List.Item>
                        <b>Diagnostico</b>
                        <br></br> {diagnostico}
                      </List.Item>
                      <List.Item>
                        <b>Tratamiento</b>
                        <br></br> {tratamiento}
                      </List.Item>
                      <List.Item>
                        {appConfigParams.emitirReceta === 1 ? (
                          <IconButton
                            size="sm"
                            circle
                            onClick={() => setModalReceta(true)}
                            placement="left"
                            icon={<SearchIcon />}
                            appearance="ghost"
                          ></IconButton>
                        ) : (
                          ""
                        )}
                        &nbsp;
                        <b>Indicaciones</b>
                        <br></br>
                        {getFinalText(indicaciones)}
                      </List.Item>
                    </List>
                  </div>
                </div>
                <Panel header="Laboratorios y/o Estudios de Gabinete" bordered>
                  <div className="row mb-3">
                    <div className="col">
                      <Input
                        as="textarea"
                        style={{ width: "100%" }}
                        rows={2}
                        value={labsEstudiosEx}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      {imageList.length > 0 ? (
                        <Carousel
                          autoplay
                          autoplayInterval={4000}
                          shape="bar"
                          height={120}
                        >
                          {imageList.map((el, index) => {
                            if (el.tipoDoc === "File") {
                              return (
                                <div key={index}>
                                  <br></br>
                                  <ul>
                                    <a
                                      style={{ color: "white" }}
                                      href={`Images/Negocios/${idNegocio}/Expedientes/${idPac}/Consultas/${idConsulta}/${el.doc}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {el.doc}
                                    </a>
                                  </ul>
                                </div>
                              );
                            } else {
                              return (
                                <div key={index}>
                                  <a
                                    style={{ color: "white" }}
                                    href={`Images/Negocios/${idNegocio}/Expedientes/${idPac}/Consultas/${idConsulta}/${el.doc}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {/* <img
                                      height="200"
                                      alt="Archivo"
                                      src={`Images/Negocios/${idNegocio}/Expedientes/${idPac}/Consultas/${idConsulta}/${el.doc}`}
                                    ></img> */}
                                    {el.doc}
                                  </a>
                                </div>
                              );
                            }
                          })}
                        </Carousel>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-lg-8 col-lg-md-8 col-sm-8">
                      <b>Notas</b>
                      <Input
                        as="textarea"
                        rows={3}
                        placeholder="Anotaciones..."
                        readOnly
                        value={observaCita}
                      />
                    </div>
                  </div>
                  {esMedicoLab === 1 ? (
                    ""
                  ) : appConfigParams.esLaboratorio === 0 ? (
                    ""
                  ) : (
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <b>Médico(s) asignado(s)</b>
                        <Input
                          readOnly
                          placeholder="Médicos..."
                          value={medicosAsignados}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <b>Agregar Médico</b>
                        <SelectPicker
                          searchable={false}
                          data={listaMedicosLab}
                          style={{ width: "100%" }}
                          block
                          placeholder="Selecciona al médico"
                          onChange={(e) => addMedico(e)}
                        ></SelectPicker>
                      </div>
                    </div>
                  )}
                </Panel>
              </Drawer.Body>
            </Drawer>

            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL RECETA MÉDICA */}
            <Modal size="lg" open={modalReceta} onClose={handleClose}>
              <Modal.Header>
                <Modal.Title>Indicaciones (Receta Médica)</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <hr></hr>
                <div ref={componentRef}>
                  <div className="row">
                    <div className="col">
                      <table style={{ width: "100%" }} border={0}>
                        <tr>
                          <td style={{ width: "50%" }}>{diagnostico}</td>
                          <td>{getFinalText(indicaciones)}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <hr></hr>
              </Modal.Body>
              <Modal.Footer>
                <Button appearance="primary" onClick={handlePrint}>
                  Imprimir
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: NumberInput,
  date: DatePicker,
  select: SelectPicker,
};

const EditableCell = ({
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          searchable={false}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
          style={{ height: "30px", width: "99%" }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const saveObs = async (id, rowData, estatus) => {
  if (estatus === undefined) {
    return;
  }
  var url = "Consultas/saveItem";
  const idNegocio = JSON.parse(localStorage.getItem("auth")).id;
  const idPaciente = JSON.parse(
    localStorage.getItem("dataPaciente"),
  ).idPaciente;

  const data = {
    id: idNegocio,
    idPaciente: idPaciente,
    idAnteced: rowData.idAnteced,
    noItem: rowData.id,
    valorado: rowData.valorado,
    obs: rowData.observacion,
  };

  await axios
    .post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (res) => {
      console.log(res);
    })
    .catch((error) => {
      console.log(error);
    });
};

const ActionCell = ({
  rowData,
  dataKey,
  onEdit,
  onSave,
  onRemove,
  ...props
}) => {
  return (
    <Cell {...props} style={{ padding: "6px", display: "flex", gap: "4px" }}>
      <IconButton
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          saveObs(rowData.id, rowData, rowData.status);
          onEdit(rowData.id);
        }}
      />
    </Cell>
  );
};
